import humps from 'lodash-humps-ts';
import { omit } from 'lodash';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { HealthClaim, HealthClaimTypes } from '@models/HealthClaim';
import { InsuranceTypes } from '@models/InsuranceType';
import { API_V1_BASE } from '@config';
import { PaymentInfo } from '@models/PaymentInfo';

export interface CreateHealthClaimParams {
  healthOrderId: number;
  claimType: HealthClaimTypes;
  insuranceType: InsuranceTypes;
  supportingDocuments: File[];
  totalClaimedAmount: number;
  acceptTermsAndConditions: boolean;
  mobileNumber: string;
  email?: string;
  paymentInfo: PaymentInfo;
}

export interface GetHealthClaimParams {
  id: number;
}

export class HealthClaimApi {
  static create = async ({ paymentInfo, ...rest }: CreateHealthClaimParams) => {
    return await authAxios
      .postForm(`${API_V1_BASE}/user/health_claims`, {
        ...omit(snakes(rest), ['supporting_documents']),
        'payment_info[payment_method]': paymentInfo.paymentMethod,
        'payment_info[bank_name]': paymentInfo.bankName,
        'payment_info[beneficiary_name]': paymentInfo.beneficiaryName,
        'payment_info[bank_account]': paymentInfo.bankAccount,
        'supporting_documents[]': rest.supportingDocuments,
      })
      .then((response) => humps(response.data) as HealthClaim);
  };

  static get = async ({ id }: GetHealthClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/health_claims/${id}`)
      .then((response) => humps(response.data) as HealthClaim);
  };
}
